import { useCurrentUser } from '@/hooks';
import { Divider, Icon, ListItemIcon, ListItemText, MenuItem } from '@/ui';

import RescheduleMenuItem from './Reschedule';

import type { Session } from '@/types';
import type { FC } from 'react';

import { canCancelSession } from '@/features/appointments/sessionCapabilities';

interface UpcomingMenuItemsProps {
  enforceMemberRescheduleMinimumNotice?: boolean;
  enforceMemberRescheduleStartBoundary?: boolean;
  handleOnClose: (e: Event | React.SyntheticEvent) => void;
  onCancel?: (val: Session) => void;
  onMessage?: (e: React.MouseEvent<HTMLElement>) => void;
  onReschedule?: (val: Session) => void;
  onViewProfile?: (e: React.MouseEvent<HTMLElement>) => void;
  session: Session;
}

const UpcomingMenuItems: FC<UpcomingMenuItemsProps> = ({
  enforceMemberRescheduleMinimumNotice,
  enforceMemberRescheduleStartBoundary,
  session,
  handleOnClose,
  onViewProfile = undefined,
  onMessage = undefined,
  onReschedule = undefined,
  onCancel = undefined,
}) => {
  const { user } = useCurrentUser();
  const concerningUser =
    session.coachId === user.id ? session.user : session.coach;
  // Capability rules live in `sessionCapabilities` so `Menu/Next` shares
  // the exact same predicate for hiding an action the API would reject.
  const showCancel = canCancelSession(session);
  return (
    <>
      <RescheduleMenuItem
        enforceMemberRescheduleMinimumNotice={
          enforceMemberRescheduleMinimumNotice
        }
        enforceMemberRescheduleStartBoundary={
          enforceMemberRescheduleStartBoundary
        }
        handleOnClose={handleOnClose}
        session={session}
        onReschedule={onReschedule}
      />
      {onCancel && showCancel ? (
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleOnClose(e);
            onCancel(session);
          }}
        >
          <ListItemIcon>
            <Icon>trash</Icon>
          </ListItemIcon>
          <ListItemText>Cancel</ListItemText>
        </MenuItem>
      ) : null}
      {(!!onViewProfile || !!onMessage) && <Divider className="mx-3" />}
      {!!onViewProfile && (
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleOnClose(e);
            onViewProfile(e);
          }}
        >
          <ListItemIcon>
            <Icon>account_circle</Icon>
          </ListItemIcon>
          <ListItemText>View profile</ListItemText>
        </MenuItem>
      )}
      {!!onMessage && (
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleOnClose(e);
            onMessage(e);
          }}
        >
          <ListItemIcon>
            <Icon>chat_bubble</Icon>
          </ListItemIcon>
          <ListItemText>Message {concerningUser.fullName}</ListItemText>
        </MenuItem>
      )}
    </>
  );
};

export default UpcomingMenuItems;
